import type { ComponentType } from 'react'

import {
  IconExperience,
  IconFamily,
  IconMasks,
  IconMusic,
  IconMusicales,
  IconPalette,
  IconParty,
  IconSport,
  type IconProps,
} from '@/app/components/atoms/Icons'

type IconComponent = ComponentType<IconProps>

/**
 * Icono por categoría (`MenuCategory.nicename` → icono). El backend
 * (`/layout`) no envía icono; se reutilizan los iconos temáticos ya
 * existentes del Design System en vez de crear SVGs nuevos (research.md §8).
 * Cualquier `nicename` sin mapeo explícito usa `FALLBACK_CATEGORY_ICON`.
 */
export const CATEGORY_ICON_MAP: Readonly<Record<string, IconComponent>> = {
  conciertos: IconMusic,
  teatro: IconMasks,
  musicales: IconMusicales,
  festivales: IconParty,
  deporte: IconSport,
  cultura: IconPalette,
  experiencias: IconExperience,
  familia: IconFamily,
}

/** Icono por defecto para una categoría sin mapeo explícito (research.md §8). */
export const FALLBACK_CATEGORY_ICON: IconComponent = IconMusic

/**
 * Analítica (`components-fingerprint/Menú categorías.csv` → "click en un
 * icono de categoría"). Módulo transversal, sin instancia previa en el repo
 * (`grep -rl "category_nav"` no encuentra nada): valores LITERALES del único
 * ejemplo del CSV, no una convención inventada.
 */
export const EXPLORA_ANALYTICS_CLICK_TYPE = 'card'
export const EXPLORA_ANALYTICS_CLICK_SUBTYPE = 'category_nav'
export const EXPLORA_ANALYTICS_MODULE_NAME = 'category_nav_menu'
